/**
 * @Description: 实时之最
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2021-09-10 15:37:21
 * @LastEditors: 琴时
 * @LastEditTime: 2021-09-24 10:53:53
 * @FilePath: \ly-sm-yxxt-ui\src\containers\Show-new\_CenterBottomBox2.js
 */
import React from 'react'
import { Row, Col } from 'antd'
import styles from './styles.css'
import NHFetch from '../../utils/NHFetch.js'
const yxxtBasicUrl = 'api/zhxg-yxxt' //迎新管理服务后台接口基础路径
const errMaxCount = 3 // 请求异常最大次数
const speed = 15 * 1000 //轮询时间间隔
export default class _CenterBottomBox2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errCount: 0, //连续请求错误次数
      cardData: [], //实时之最统计数据
    }
    this.polling //轮询定时器
  }

  componentDidMount() {
    this.getData()
  }

  // 组件卸载时清除定时器
  componentWillUnmount() {
    if (this.polling) {
      clearTimeout(this.polling)
    }
  }

  getData = () => {
    NHFetch(yxxtBasicUrl + '/sstj/getRealTimeStatisticsForMaximumItemByLcid', 'GET',{pkid: this.props.pkid})
      .then(res => {
        if (res && res.data) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount: 0, cardData: res.data })
        }
      })
      .catch(err => {
        let errCount = this.state.errCount
        //如果请求异常次数未超过最大次数限制，则继续尝试
        if (errCount < errMaxCount) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount: errCount + 1 })
        } else {
          //异常超过3次后终止轮询
          clearTimeout(this.polling)
        }
      })
  }

  transformDecimal = (number, i) => {
    let decimalNum = null
    // 先转换为数值型
    let num = Number(number)
    // 判断是否为数值型
    if (!isNaN(num)) {
      // 切分整数与小数
      let arr = num.toString().split('.')
      // 是小数且小数位大于保留个数
      if (arr.length > 1 && arr[1].length > i) {
        // 小数部分字符串
        let decimal = arr[1].slice(i, i + 1)
        // toFixed 有 bug，四舍六入五随机
        // 当四舍五入的数为 5，给其 + 1
        if (decimal === '5') {
          // 这里可能会存在 0.1 ** 5 = 0.000010000000000000003 但不影响四舍五入
          num += Math.pow(0.1, i + 1)
        }
        decimalNum = num.toFixed(i)
      } else {
        decimalNum = num
      }
      decimalNum = Number(decimalNum)
    }
    return decimalNum
  }

  render() {
    const { cardData = [] } = this.state
    let cardDataTemp = [
      { itemName: '最强星座', itemValue: '暂无', itemCount: 0 },
      { itemName: '最小年龄', itemValue: '暂无', itemCount: 0 },
      { itemName: '同名同姓', itemValue: '暂无', itemCount: 0 },
      { itemName: '同月同日', itemValue: '暂无', itemCount: 0 },
      { itemName: '最大体重', itemValue: '暂无', itemCount: 0 },
      { itemName: '最大身高', itemValue: '暂无', itemCount: 0 },
    ]
    const newCardData = cardDataTemp.map(item => {
      cardData.some(element => {
        if (element.itemName === item.itemName) {
          item = element
          return true
        }
        return false
      })
      return item
    })
    const cardObj = newCardData.shift() //将最强星座切割出来
    let xz = '',
      img = ''
    if (cardObj && cardObj.itemValue === '白羊座') xz = 'byz'
    else if (cardObj && cardObj.itemValue === '处女座') xz = 'cnz'
    else if (cardObj && cardObj.itemValue === '双子座') xz = 'dzz'
    else if (cardObj && cardObj.itemValue === '金牛座') xz = 'jnz'
    else if (cardObj && cardObj.itemValue === '巨蟹座') xz = 'jxz'
    else if (cardObj && cardObj.itemValue === '摩羯座') xz = 'mjz'
    else if (cardObj && cardObj.itemValue === '水瓶座') xz = 'spz'
    else if (cardObj && cardObj.itemValue === '射手座') xz = 'ssz'
    else if (cardObj && cardObj.itemValue === '双鱼座') xz = 'syz'
    else if (cardObj && cardObj.itemValue === '狮子座') xz = 'szz'
    else if (cardObj && cardObj.itemValue === '天秤座') xz = 'tcz'
    else if (cardObj && cardObj.itemValue === '天蝎座') xz = 'txz'
    if (xz) img = require(`./images/constellation/${xz}.png`)

    return (
      <div className={styles.box_2_bottom_com}>
        <span className={styles.box_title} style={{ top: '0px' }}>
          实时之最
        </span>
        <Row>
          <Col span={6}>
            <div className={styles.layoutBox1}>
              <span className={styles.span_while}>最强星座</span>
              <div className={styles.box_m_b1}>
                {img && <img src={img} alt='星座' width='50px' />}
                <span className={styles.span_xz}>
                  {cardObj && cardObj.itemValue}
                </span>
              </div>
              <span className={styles.span_blue}>{cardObj.itemCount}人</span>
            </div>
          </Col>
          <Col span={18} className={styles.layoutBox2}>
            {newCardData.map((item, index) => {
              return (
                <div className={styles.layoutBox3} key={index}>
                  <span className={styles.span_while}>{item.itemName}</span>
                  <div className={styles.box_m_b2}>
                    <span className={styles.span_bjb}>{item.itemValue}</span>
                  </div>
                  <span className={styles.span_blue}>{item.itemCount}人</span>
                </div>
              )
            })}
          </Col>
        </Row>
        <style jsx='true'>
          {`
            .ant-row {
              height:100%;
              display:flex;
              align-items:center;
            }
            `}
        </style>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/Show-new/_CenterBottomBox2.js